import { Controller } from '@hotwired/stimulus'
import consumer from '~/channels/consumer'

export default class extends Controller {
  static targets = ['list', 'filters', 'search']

  static values = {
    refreshUrl: String
  }

  connect() {
    this.subscribeToChannel()
  }

  disconnect() {
    this.unsubscribeFromChannel()
  }

  subscribeToChannel() {
    this.subscription = consumer.subscriptions.create(
      { channel: 'AdminSupportChannel' },
      {
        received: (data) => this.handleChannelMessage(data)
      }
    )
  }

  unsubscribeFromChannel() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleChannelMessage(data) {
    switch (data.event) {
      case 'new_ticket':
        this.handleNewTicket(data.ticket)
        break
      case 'ticket_updated':
        this.handleTicketUpdated(data.ticket)
        break
      case 'new_message':
      case 'ticket_reply':
        this.handleNewMessage(data.ticket_id)
        break
      case 'new_chat_session':
      case 'chat_message':
        this.refresh()
        break
    }
  }

  handleNewTicket(ticket) {
    this.showNotification(`New ticket #${ticket.ticket_number}: ${ticket.subject}`, 'info')
    this.refresh()
  }

  handleTicketUpdated(_ticket) {
    this.refresh()
  }

  handleNewMessage(_ticketId) {
    this.refresh()
  }

  refresh() {
    if (this.hasRefreshUrlValue) {
      fetch(this.refreshUrlValue, {
        headers: { 'Accept': 'text/html' }
      })
        .then((response) => response.text())
        .then((html) => {
          if (this.hasListTarget) {
            this.listTarget.innerHTML = html
          }
        })
    } else {
      window.location.reload()
    }
  }

  search(_event) {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      this.submitFilters()
    }, 300)
  }

  filter() {
    this.submitFilters()
  }

  submitFilters() {
    if (this.hasFiltersTarget) {
      this.filtersTarget.submit()
    }
  }

  showNotification(message, type = 'info') {
    const colors = {
      info: 'bg-blue-50 border-blue-500 text-blue-700',
      success: 'bg-green-50 border-green-500 text-green-700',
      error: 'bg-red-50 border-red-500 text-red-700'
    }

    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 z-50 p-4 rounded border-2 ${colors[type] || colors.info}`
    notification.textContent = message

    document.body.appendChild(notification)

    setTimeout(() => {
      notification.remove()
    }, 5000)
  }
}
